const createWalletApi = ({ application }) => {
    return {
        wallet: {
            start: application.start,
            stop: application.stop,
            create: application.create,
            clear: () => application.fire('clear'),
            load: application.load,
            lock: application.lock,
            unlock: application.unlock,
            import: application.import,
        },
    };
};
const walletApiDefinition = {
    id: 'walletApi',
    type: 'api',
    factory: createWalletApi,
    dependencies: ['application'],
};
export default walletApiDefinition;
